// extracted by mini-css-extract-plugin
export default {"optItem":"optItem"};